import React from "react";
import DocumentVerificationLogin from "../components/DocumentVerification/DocumentVerificationLogin";

const DocumentVerificationLoginScreen = () => <DocumentVerificationLogin />;

export default DocumentVerificationLoginScreen;
